import portal from '@/axios/postcode';

export default {
  getAddress(postcode, number) {
    return portal.get(`/postcode/full?postcode=${postcode}&number=${number}`);
  },
};
